import clsx from 'clsx';
import { withMask } from 'use-mask-input';

import { AcceptIcon } from '@/assets/react-icons/AcceptIcon';
import { EditIcon } from '@/assets/react-icons/EditIcon';
import { Button } from '@/components/Button';
import { Input } from '@/components/Input';
import { Loader } from '@/components/Loader';
import { Text } from '@/components/Text';

import styles from './PersonalIdentificationDocument.module.scss';

type Props = {
  className?: string;
  errorId?:
    | {
        message?: string;
      }
    | undefined;
  errorNumber?:
    | {
        message?: string;
      }
    | undefined;
  errorSeries?:
    | {
        message?: string;
      }
    | undefined;
  idCard: string;
  isEditBlockMode: boolean;
  isLoading?: boolean;
  number: string;
  onEdit: () => void;
  onIDCardChange: (value: string) => void;
  onNumberChange: (value: string) => void;
  onSave: () => void;
  onSeriesChange: (value: string) => void;
  series: string;
};

export const PersonalIdentificationDocument = ({
  className,
  errorId,
  errorNumber,
  errorSeries,
  idCard,
  isEditBlockMode,
  isLoading,
  number,
  onEdit,
  onIDCardChange,
  onNumberChange,
  onSave,
  onSeriesChange,
  series,
}: Props) => {
  const seriesMaskRef = withMask('AA');

  const numberMask = withMask('999999');

  const idCardMask = withMask('999999999');

  const onSeriesInputChange = (value: string) => {
    if (value.length > 2) {
      onSeriesChange('');
    } else {
      onSeriesChange(value.toUpperCase()); // Продовжуємо роботу з нормальним значенням
    }
  };

  return (
    <div className={clsx(styles.wrapper, !isEditBlockMode && styles.isSaved, className)}>
      <div className={styles['identity-left']}>
        <Text type='p2'>Дані документа, що посвідчує особу</Text>
        <Text color='text-gray' style={{ display: 'flex' }} type='p3'>
          Введіть дані паспорту чи ID-картки фактичного власника ділянки
        </Text>
        {isEditBlockMode ? (
          <div className={styles['identity-inputs-wrapper']}>
            <Input
              error={errorSeries}
              onChange={(e) => onSeriesInputChange(e.target.value)}
              placeholder='Серія'
              ref={seriesMaskRef}
              value={series}
            />
            <Input
              error={errorNumber}
              onChange={(e) => onNumberChange(e.target.value)}
              placeholder='Номер'
              ref={numberMask}
              value={number}
            />
            <Text type='field_text'>або</Text>
            <Input
              error={errorId}
              onChange={(e) => onIDCardChange(e.target.value)}
              placeholder='№ Документу (ID-картка)'
              ref={idCardMask}
              value={idCard}
            />
          </div>
        ) : (
          <div className={styles.validTextRow}>
            <Text color='text-gray' type='p3'>
              {series ? 'Серія та номер паспорту:' : 'Номер ID карти:'}
            </Text>{' '}
            <Text color='black' type='p3'>
              {series ? series + number : idCard}
            </Text>
          </div>
        )}
      </div>
      <div className={styles['identity-right']}>
        {isEditBlockMode ? (
          <div className={styles.btnSaveCont}>
            {isLoading && <Loader />}
            <Button disabled={isLoading} icon={<AcceptIcon />} onClick={onSave} small>
              Зберегти
            </Button>
          </div>
        ) : (
          <Button icon={<EditIcon />} onClick={onEdit} small>
            Редагувати
          </Button>
        )}
      </div>
    </div>
  );
};
